// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://apigopaljewels.manjitjewellers.com/",
});

export default axiosInstance;

export const weburl = "https://apigopaljewels.manjitjewellers.com/";
// export const weburl = "https://api.manjitjewellers.com/";

export const Homeurl = "https://parijaapp.servicekarwalo.com/";
export const adminurl = "https://app.manjitjewellers.com/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://apigopaljewels.manjitjewellers.com/';
export const Host = 'https://gopaljewelscloud.manjitjewellers.com/';

// export const weburl = 'https://backend-2o7f.onrender.com/';
